import Header from "../Header/Header";
import Sidebar from "../SideBar/SideBar";
const Layout = ({ children }) => {
    return (
        <div className="container-fluid g-0 height_with_floats">
            <div className="row height_with_floats" >
                <div className="col-12 height_with_floats">
                    <div className="row height_with_floats">
                        <div className="col-2 col-md-2 col-lg-2 col-sm-2">
                            <Sidebar />
                        </div>
                        <div className="col-10 col-md-10 col-lg-10 col-sm-10 layout_body">
                            <div className="row">
                                <div className="col-12">
                                    <Header />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-12  p-0 ms-2 layout-content" >
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
